import { FC, useState } from "react";
import { GridApi } from "ag-grid-community";
import { Stack } from "@mui/material";
import { AgDataGrid } from "@/components/pages/common/ag-grid/AgDataGrid";
import { useAppSelector } from "@/store/hooks";
import { dashboardHierarchyMixedVisibilitiesDataSelector } from "@/store/dashboards/selectors/dashboard-hierarchy-visibility/dashboardHierarchyMixedVisibilitiesDataSelector";
import {
  dashboardAllItemsAutoGroupColumnDef,
  dashboardAllItemsColDef,
} from "@/components/pages/dashboard-all-items/components/table/components/dashboardAllItemsAgGridColDefs";
import { dashboardHierarchyVisibilitiesLoadingSelector } from "@/store/dashboards/selectors/dashboard-hierarchy-visibility/dashboardHierarchyVisibilitiesLoadingSelector";
import { HierarchyAllItemsAgGridToolbar } from "@/components/pages/common/hierarchy-all-items/components/HierarchyAllItemsAgGridToolbar";
import { DashboardAllItemsTableNoData } from "@/components/pages/dashboard-all-items/components/table/components/DashboardAllItemsTableNoData";
import {
  getHierarchyAllItemsRowClass,
  hierarchyAllItemsGridDefaultColDef,
  hierarchyAllItemsGridIcons,
  hierarchyAllItemsGridWrapperStyles,
} from "@/components/pages/common/hierarchy-all-items/utils/constants/gridConstants";
import { ConfigToRememberStateInStorage } from "@/components/pages/common/ag-grid/utils/types/gridProps";

export const DashboardAllItemsAgGrid: FC = () => {
  const [gridApi, setGridApi] = useState<GridApi | null>(null);

  const data = useAppSelector(dashboardHierarchyMixedVisibilitiesDataSelector);
  const loading = useAppSelector(dashboardHierarchyVisibilitiesLoadingSelector);

  return (
    <Stack height="100%">
      <HierarchyAllItemsAgGridToolbar gridApi={gridApi} />
      <AgDataGrid
        rowData={data}
        rowHeight={52}
        treeData={true}
        loading={loading}
        headerHeight={52}
        groupTotalRow="bottom"
        grandTotalRow="bottom"
        gridApiSetter={setGridApi}
        suppressStickyTotalRow="group"
        treeDataChildrenField="children"
        icons={hierarchyAllItemsGridIcons}
        columnDefs={dashboardAllItemsColDef}
        getRowClass={getHierarchyAllItemsRowClass}
        defaultColDef={hierarchyAllItemsGridDefaultColDef}
        wrapperStyles={hierarchyAllItemsGridWrapperStyles}
        noRowsOverlayComponent={DashboardAllItemsTableNoData}
        autoGroupColumnDef={dashboardAllItemsAutoGroupColumnDef}
        configToRememberStateInStorage={configToRememberStateInStorage}
      />
    </Stack>
  );
};

const configToRememberStateInStorage: ConfigToRememberStateInStorage = {
  uniqueNameAsKey: "c8r-DashboardAllItemsAgGrid",
};
